import { isValid } from 'date-fns';
import { getTrans } from 'modules/i18n';
import { logError } from 'utils/datadog';
import {
  DateFormat,
  formatDateWithTimezone,
  getHoursAndMinutesLabel,
  getShortDateLabelWithTimezone,
  isMonthDifferentWithTimezone,
  isYearDifferentWithTimezone
} from 'utils/date';

export const getWeekLabelWithTimezone = (
  start: string,
  end: string,
  timezone: string
) => {
  let startLabel = formatDateWithTimezone(start, DateFormat.DAY, timezone);
  const endLabel = getShortDateLabelWithTimezone(end, timezone);

  if (isMonthDifferentWithTimezone(start, end, timezone)) {
    startLabel += ` ${formatDateWithTimezone(
      start,
      DateFormat.SHORT_MONTH,
      timezone
    )}`;
  }

  if (isYearDifferentWithTimezone(start, end, timezone)) {
    startLabel += `'${formatDateWithTimezone(
      start,
      DateFormat.SHORT_YEAR,
      timezone
    )}`;
  }

  return `${startLabel} - ${endLabel}`;
};

export const getMonthLabelWithTimezone = (
  month: number,
  year: number,
  timezone: string
) => {
  const monthNo = month < 10 ? `0${month}` : month;
  const dateString = `${year}-${monthNo}-01`;
  const date = new Date(dateString);

  if (!isValid(date)) {
    logError('Invalid date', { dateString, month, year });
    return '';
  }

  return `${formatDateWithTimezone(
    dateString,
    DateFormat.SHORT_MONTH,
    timezone
  )}'${formatDateWithTimezone(dateString, DateFormat.SHORT_YEAR, timezone)}`;
};

export const getWorkedTimeLabel = (
  expectedTime: number,
  workedTime: number
) => {
  const workedTimeLabel = getHoursAndMinutesLabel(workedTime);
  const expectedTimeLabel = getHoursAndMinutesLabel(expectedTime);

  const of = getTrans('general.of');

  return `${workedTimeLabel} ${of} ${expectedTimeLabel}`;
};
